import React from 'react';

// Error Boundary for catching rendering errors
interface ErrorBoundaryProps {
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

class ErrorBoundary extends React.Component<ErrorBoundaryProps, {hasError: boolean}> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

    static getDerivedStateFromError(_error: Error) {
    return { hasError: true };
  }

  componentDidCatch(_error: Error, errorInfo: React.ErrorInfo) {
    console.error('Error in 3D component:', errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback || <div className="text-center p-4 text-red-400">3D content couldn't load. Please refresh the page.</div>;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
